import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody, Row, Col, Label, Button, FormGroup, Spinner } from 'reactstrap';
import Select from 'react-select';
import SweetAlert from 'react-bootstrap-sweetalert';
import { convertToLowestUnit, formatUnitsForReport, GetUpdatedDelivered, mapUnits } from '../../helpers/units';
import calculatePrice from '../../helpers/calculate_price';
import showNotification from '../../helpers/show_notification';
import { AvField, AvForm } from 'availity-reactstrap-validation';
import UpdateQuantityModal from '../../components/UpdateQuantityModal';
import moment from 'moment';

// Create a new modal component for comprehensive item replacement
const ReplaceItemModal = ({
  isOpen,
  toggle,
  isLoading,
  originalItem,
  allItems,
  onReplace
}) => {
  const [selectedItem, setSelectedItem] = useState(null);
  const [selectedItemToEdit, setSelectedItemToEdit] = useState({});
  const [editQuantityModal, setEditQuantityModal] = useState(false);

useEffect(()=>{
return()=>cleanUp()
},[])

function cleanUp() {
  toggle()
  setSelectedItem(null)
  setSelectedItemToEdit({})
  setEditQuantityModal(false)
  setConfirmReplace(false)
}
  const [confirmReplace, setConfirmReplace] = useState(false);
  const oneYearFromNow = moment().add(1, 'year').format('YYYY-MM-DD');              

  // Handle item selection from dropdown
  const handleItemSelect = (selectedOption) => {    
    // here i am converting previous item order qty in lowest unit 
    let originalQuantity = convertToLowestUnit(originalItem?.unit_levels, originalItem?.quantity);
    // here i am finding lowest unit 
    let lastUnitObj = selectedOption.unit_levels.at(-1).unit;
    // here i am making new qty in lowest unit of new item,  
    let quantity = [{ unit: lastUnitObj, value: originalQuantity }]
    let qtyForNewItem = GetUpdatedDelivered(quantity, selectedOption.unit_levels)

    let item = {
      item_id: selectedOption._id,
      _id: selectedOption._id,
      label: selectedOption.name,
      remarks:"",
      value: selectedOption._id,
      name: selectedOption.name,
      category: selectedOption.category,
      sub_category: selectedOption.sub_category,
      brand: selectedOption.brand,
      quantity: qtyForNewItem,
      receive: qtyForNewItem,
      unit_for_po: selectedOption?.unit_for_po,
      price: selectedOption?.po_price ??   (originalItem?.price || 0),
      total_price: calculatePrice(originalItem.unit_levels, qtyForNewItem, originalItem?.price || 0, selectedOption.unit_for_po) || 0,
      expiry_date: oneYearFromNow,
      unit_levels: selectedOption.unit_levels
    }
    setSelectedItem(item);
  };

  // Handle changes in replacement details
  const handleDetailChange = (value,key) => {
    setSelectedItem(prev => ({
      ...prev,
      [key]: value
    }));
  };

  // Prepare replacement submission
  const handleSubmitReplacement = () => {
    if (!selectedItem) {
      showNotification('Please select an item to replace', 'warning');
      return;
    }
    setConfirmReplace(true);
  };

  // Confirm replacement
  const confirmReplacement = async () => {
    setConfirmReplace(prev=>prev=false)
    const res = await onReplace({
      originalItem,
      replacementItem: selectedItem,
    });
    if(res){
      cleanUp()
    }
  };


  const handleUpdateUnit = (quantity) => {
    let convertedQuantity = GetUpdatedDelivered(quantity, selectedItemToEdit?.unit_levels)
    let updatedItem = {
      ...selectedItem,
      quantity: convertedQuantity,
      receive: convertedQuantity,
      total_price: calculatePrice(originalItem.unit_levels, convertedQuantity, selectedItemToEdit?.price || 0, selectedItemToEdit.unit_for_po) || 0,
    }
    setSelectedItem(updatedItem);
    setEditQuantityModal(false);

  };

  return (
    <>
      <Modal
        isOpen={isOpen}
        toggle={cleanUp}
        size="lg"
      >
        <ModalHeader toggle={cleanUp}>
          Replace Item: <strong>{originalItem?.name || 'Item'}</strong>
        </ModalHeader>
        <ModalBody>
          <Row>
            <Col lg={8} md={8}>
              <FormGroup>
                <Label style={{ textDecoration: "underline" }}>Original Item Details-</Label>
                <Row>
                  <Col lg={3} md={3}><strong>Name</strong></Col>
                  <Col lg={9} md={9}>: &nbsp;&nbsp; {originalItem?.name}</Col>
                  <Col lg={3} md={3}><strong>Current Quantity</strong></Col>
                  <Col lg={9} md={9}>: &nbsp;&nbsp; {formatUnitsForReport(originalItem?.receive || [])}</Col>
                  <Col lg={3} md={3}><strong>Current Price</strong></Col>
                  <Col lg={9} md={9}>: &nbsp;&nbsp; {originalItem?.price}/{originalItem?.unit_for_po}</Col>
                </Row>
              </FormGroup>
            </Col>
            <Col lg={4} md={4}>
              <FormGroup>
                <Label>Select Replacement Item</Label>
                <Select
                  options={allItems?.filter(data=>data._id !== originalItem?.item_id)}
                  value={selectedItem}
                  onChange={handleItemSelect}
                  placeholder="Select a new item"
                />
              </FormGroup>
            </Col>
          </Row>

          <AvForm onValidSubmit={handleSubmitReplacement}>
            {selectedItem && (
              <Row className="mt-3">
                <Col lg={4}>
                  <FormGroup>
                    <Label>Replacement Quantity</Label><br />
                    <Label>{formatUnitsForReport(selectedItem?.quantity ?? [])}</Label>
                    <Button
                      className="btn btn-success waves-effect waves-light btn-sm"
                      onClick={() => {
                        let updatedItem = {
                          ...selectedItem,
                          quantity: selectedItem.quantity?.map((item, idx) => ({
                            ...item,
                            index: idx,
                            isChecked: true,
                          })),
                        }
                        setSelectedItemToEdit(updatedItem)
                        setEditQuantityModal(true);
                      }}
                    >
                      {/* <i class="bx bxs-edit"></i> */}
                      {("Edit")}
                    </Button>
                  </FormGroup>
                </Col>
                <Col lg={4}>
                  <FormGroup>
                    <Label>Price</Label>
                    <div className="d-flex align-items-center">
                      <AvField
                        type="number"
                        style={{ height: "30px", width: "100px" }}
                        className="form-control me-2"
                        placeholder='Price'
                        name="price"
                        value={selectedItem.price}
                        onChange={(e) => handleDetailChange(e.target.value,"price")}
                        validate={{
                          required: {
                            value: true,
                          },
                          min: {
                            value: 1,
                            errorMessage: "can not be zero",
                          },
                        }}
                        errorMessage="Price can't be empty"
                      />
                      <span>&nbsp;/{selectedItem?.unit_for_po}</span>
                    </div>
                  </FormGroup>
                </Col>
               <Col lg={4}>
                  <FormGroup>
                     <Label>Formula {mapUnits(selectedItem?.unit_levels)}</Label>
                  </FormGroup>
                </Col>

                <Col lg={6} md={6}>
                <Label>Remarks *</Label>
                <AvField
                        type="textarea"
                        className="form-control me-2"
                        placeholder="Remarks"
                        name="remarks"
                        value={selectedItem.remarks}
                        onChange={(e) => handleDetailChange(e.target.value,"remarks")}
                        validate={{
                          required: {
                            value: true,
                          },
                        }}
                        errorMessage="Remark's is required"
                      />
                </Col>
              </Row>
            )}

            <Row className="mt-3">
              <Col lg={12} className="text-center">
              <hr />
                <Button
                  color="primary"
                  type='submit'
                  style={{width:"140px"}}
                  disabled={!selectedItem || isLoading}
                  // onClick={handleSubmitReplacement}
                >
                    {isLoading ? <Spinner size="sm" /> : 'Replace Item' } 
                </Button>
              </Col>
            </Row>
          </AvForm>
        </ModalBody>
      </Modal>

      <UpdateQuantityModal
        isOpen={editQuantityModal}
        toggle={() => setEditQuantityModal(false)}
        onSubmit={handleUpdateUnit}
        item={selectedItemToEdit}
      />

      

      {confirmReplace && (
        <SweetAlert
          title="Confirm Item Replacement"
          warning
          showCancel
          confirmBtnText="Yes, Replace"
          cancelBtnText="No, Cancel"
          confirmBtnBsStyle="secondary"
          cancelBtnBsStyle="danger"
          onConfirm={confirmReplacement}
          onCancel={() => setConfirmReplace(false)}
        >
          Are you sure you want to replace this item? This action cannot be undone.
        </SweetAlert>
      )}
    </>
  );
};
export default ReplaceItemModal

